import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'alpha.100',
    endColor: 'alpha.200',
    minW: 'full',
    h: '20',
    borderRadius: 'lg',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    sxWrapper: { mb: '0' },
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.05)',
    borderRadius: 'md',
    color: 'white',
    mb: '0',
    border: 'none',
    bg: 'blackAlpha.600',
    _hover: {
      '&&': {
        _placeholder: {
          color: 'gray.400',
        },
      },
      color: 'white',
    },
    _focus: {
      '&&': {
        bg: 'blackAlpha.600',
        _placeholder: {
          color: 'gray.400',
        },
      },
      color: 'beta.400',
      textShadow: 'sm',
    },
    _placeholder: {
      color: 'whiteAlpha.500',
      fontWeight: 'bold',
      fontSize: '2xs',
    },
    sx: {
      '&&': {
        bg: 'blackAlpha.600',
        _placeholder: {
          color: 'whiteAlpha.400',
        },
      },
    },
  },
  inputRightIcon: {
    color: 'beta.400',
    boxSize: '4',
    as: Search,
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    borderBottom: '1px solid',
    borderBottomColor: 'rgba(0, 0, 0, 0.24)',
    py: '2',
    borderTop: 'none',
    _last: {
      borderBottom: 'none',
    },
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: { alignItems: 'center', gap: 2, flex: 1, textAlign: 'left' },
  accordionButtonIconSvg: {
    color: 'alpha.800',
    fontSize: 'md',
  },
  accordionButtonText: {
    fontSize: ['xs', 'sm'],
    fontWeight: 'normal',
    color: 'white',
    letterSpacing: 'widest',
    fontFamily: 'Bowlby One',
    textTransform: 'uppercase',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.20)',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: '2xs',
    fontWeight: 'bold',
    color: 'white',
  },
  accordionButtonInnerIcon: {
    pos: 'absolute',
    right: '0',
    boxSize: '6',
    color: 'white',
  },
  accordionPanel: {
    p: '0',
    mb: '3',
  },
};
